export default {
  header: "We're Sorry.",
  primaryButtonText: "Try Again",
  secondaryButtonText: "Save for Later",
};
